import { styled } from '@mui/system';
import { Box } from '@mui/material';

export const Container = styled(Box)({
  height: '100%',
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});
